import type { MessageStatsBucketsItem } from "@/api/generated/model"

export type TrafficDay = MessageStatsBucketsItem & {
  previous?: MessageStatsBucketsItem | undefined
}

/**
 * The previous window beside the current one, day N against day N: the two
 * windows cover different dates, and "the 5th day of this period against
 * the 5th of the last" is the comparison the overlay draws.
 */
export function alignByDayOffset(
  current: readonly MessageStatsBucketsItem[],
  previous: readonly MessageStatsBucketsItem[] | undefined,
): TrafficDay[] {
  return current.map((d, i) => ({ ...d, previous: previous?.[i] }))
}

/** At most this many date labels under the chart, whatever the range. */
const MAX_TICKS = 8

/** The days that get a date label: every day for a week, evenly thinned beyond. */
export function tickIndices(days: number): number[] {
  if (days <= 0) return []
  const every = Math.ceil(days / MAX_TICKS)
  const out: number[] = []
  for (let i = 0; i < days; i += every) out.push(i)
  return out
}

export function totals(days: readonly MessageStatsBucketsItem[]): {
  sent: number
  received: number
} {
  return days.reduce((t, d) => ({ sent: t.sent + d.sent, received: t.received + d.received }), {
    sent: 0,
    received: 0,
  })
}
